import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { useStyles } from '../styles/NewOrUpdateForm.styles';
import React from 'react';

interface ManageFormProps {
    title: string;
    children: React.ReactNode;
    loading?: boolean;
    size?: number;
    centered?: boolean;
}

export const ManageForm = ({ title, children, size, loading = false, centered = false }: ManageFormProps) => {
    const classes = useStyles();

    return (
        <Box
            className={classes.root}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                overflow: 'auto',
                height: '100%',
            }}>
            <Typography className={classes.dashboardTitle} component='h1' textAlign={centered ? 'center' : undefined}>
                {title}
            </Typography>
            {loading ? (
                <Box display='flex' justifyContent='center' alignItems='center' height='100%' width='100%'>
                    <CircularProgress size='5rem' />
                </Box>
            ) : (
                <Grid container>
                    <Grid item md={size ?? 7} xs={12} lg={size}>
                        <Grid container spacing={2}>
                            {!loading && children}
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};
